module.exports = __webpack_public_path__ + "static/media/TrainSchedulerFrame.3219fdf5.png";